var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTimelinePremiumContributionPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.74c-5.523 0-10-4.476-10-10 0-5.522 4.477-10 10-10s10 4.478 10 10c0 5.524-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm1-7h3v2h-3v2h-2v-2H8v-2h3v-1H8v-2h2.586L8.464 8.62 9.88 7.205 12 9.327l2.121-2.122 1.415 1.415-2.122 2.12H16v2h-3v1z",
    fill: "gray"
  })));
}

export default SvgIconTimelinePremiumContributionPrice;